<template>
    <div>
        <card-header title="WIAA Certification Details" icon="fa-certificate"/>

        <card-toolbar>
            <button @click="$openCard('wiaa-edit-id', {userId: user.id}, card)"><i class="far fa-pencil"></i>Edit WIAA ID</button>
        </card-toolbar>

        <card-body subheader toolbar>
            <card-list>
                <subheader-list-item title="User Information" icon="fa-user"/>
            </card-list>

            <data-row title="Full Name">
                <span class="is-clickable" @click="$copyText(user.first_name + ' ' + user.last_name)">{{user.first_name}} {{user.last_name}}</span>
            </data-row>
            <data-row title="E-Mail Address"><span class="is-clickable" @click="$copyText(user.email)">{{user.email}}</span></data-row>
            <data-row title="Alt E-Mail" v-if="user.email_2"><span class="is-clickable" @click="$copyText(user.email_2)">{{user.email_2}}</span></data-row>
            <data-row title="WIAA ID">
                <span class="is-clickable" @click="$copyText(user.certification_number)">{{user.certification_number || 'Not Set'}}</span>
            </data-row>
            <data-row title="School" v-if="user.school_name">{{user.school_name}}</data-row>
            <data-row title="District" v-if="user.district_name">{{user.district_name}}</data-row>
            <data-row title="User ID"><span class="is-clickable" @click="$copyText(user.id)">{{user.id}}</span></data-row>
            <data-row title="Registration Date">{{user.created_at | moment('MMM Do, YYYY h:mm A')}}</data-row>

            <card-list>
                <subheader-list-item title="WIAA Certifications" icon="fa-certificate" :badge="certifications.length"/>
            </card-list>

            <container-list-item padded v-if="loading" class="has-text-grey is-size-7">
                <i class="fas fa-spinner fa-spin fa-fw mr-2 ml-2"></i>Loading certifications...
            </container-list-item>

            <container-list-item padded v-if="!loading && certifications.length === 0" class="has-text-grey is-size-7">
                No WIAA certifications found for this user
            </container-list-item>

            <card-list v-if="certifications.length > 0">
                <wiaa-certification-detail-tile 
                    v-for="cert in certifications" 
                    :key="cert.id"
                    :certification="cert"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import DataRow from "@/TIER/components/DataRow";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import WiaaCertificationDetailTile from "../../components/tiles/WiaaCertificationDetailTile";
    import {client as http} from '@/http_client';
    import { mapGetters } from "vuex";

    export default {
        components: {
            ContainerListItem,
            SubheaderListItem,
            CardList,
            NavigationListItem,
            DataRow,
            CardBody,
            CardHeader,
            CardToolbar,
            WiaaCertificationDetailTile
        },
        props: ['card', 'props', 'child'],
        data() {
            return {
                user: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    email_2: '',
                    certification_number: '',
                    school_name: '',
                    district_name: '',
                    id: '',
                    created_at: ''
                },
                certifications: [],
                loading: true
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            loadUserCertifications: function (force) {
                this.$emit('loading', true);
                this.loading = true;
                
                http.get(`wiaa/user/${this.props.userId}/certifications`, {force}).then(response => {
                    if (response.data) {
                        this.user = response.data.user || {};
                        this.certifications = response.data.certifications || [];
                    }
                    this.loading = false;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading WIAA certifications:', err);
                    this.loading = false;
                    this.$emit('loading', false);
                    this.$buefy.toast.open({
                        message: 'Error loading certification details',
                        type: 'is-danger',
                        duration: 3000
                    });
                });
            },
            reload: function() {
                this.loadUserCertifications(true);
            }
        },
        watch: {
            'props': function (n, o) {
                if (n.userId !== o.userId) this.loadUserCertifications();
            }
        },
        mounted: function () {
            this.loadUserCertifications();
        }
    };
</script>

<style lang="scss" scoped>

</style>